import {FileDto} from './file';
import { ItemRecordColumn } from './item-record-columns';

export interface Comment {
  id: number;
  comment: string;
  /**
   * Date of creation in String format
   */
  createdDate: string;
}

export interface Form {
  id: number;
  code: string;
  name: string;
  formTypeId: number;
  formSubTypeId: number;
  active: boolean;
  questions: Question[];
  comments: Comment[];
  history?: {
    statusId: number;
    followUpActionId: number;
    comment: string;
    createdDate: string;
    createdBy: string;
    status: {
      id: number;
      description: string;
    },
    // followUpAction: {}
  }[];
}

export interface PosibleAnswer {
  id: number;
  code: string;
  description: string;
  requiresExplanation: boolean;
  color: string;
}

export type AttachmentFile = FileDto;

export interface QuestionAttachment {
  id: number;
  fileId: number;
  file: AttachmentFile;
  createdDate: string;
}

export interface TableDimensions {
  id: number;
  code: string;
  description: string;
}

export enum GroupOp {
  AND =   'AND',
  OR  =   'OR'
}

export enum ComparableOperator {
  Equal = "Equal",
  NotEqual = "NotEqual",
  Contains = "Contains",
  StartWith = "StartWith",
  EndWith = "EndWith",
  In = "In",
  GreaterThan = "GreaterThan",
  GreaterThanOrEqual = "GreaterThanOrEqual",
  LessThan = "LessThan",
  LessThanOrEqual = "LessThanOrEqual",
  IsNullOrEmpty = "IsNullOrEmpty",
  NotIsNullOrEmpty = "NotIsNullOrEmpty",
  Between = "Between",
}

export interface ConditionalItem {
  questionId: number;
  comparableOperator: ComparableOperator;
  comparableValue: any
}

export interface ConditionalGroup {
  operator: GroupOp;
  items: ConditionalItem[];
  childGroups: ConditionalGroup[];
}

export interface Question {
  answerId?: number;
  id: number;
  code: string;
  description: string;
  detail: string;
  questionTypeId: number;
  isRequired: boolean;
  commentAllowed: boolean;
  commentRequired: boolean;
  attachAllowed: boolean;
  attachRequired: boolean;
  templateFileId: number;
  possibleAnswers: PosibleAnswer[];
  dimensions?: TableDimensions[];
  answer: string;
  answerFiles: AttachmentFile[];
  attachments: QuestionAttachment[];
  comments: Comment[];
  conditionalGroup?: ConditionalGroup;
  recordColumns?: ItemRecordColumn[];
}


export interface ReportForm {
  formId: number;
  questions: QuestionReportForm[];
  comments: [],
}

export interface QuestionReportForm{
  id?: number;
  questionId: number;
  calculatedValue?: number;
  answer: string;
  comments: string[];
  attachments: number[];
}
